export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["संख्या"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नाम"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कार्रवाई"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कलेक्टर के बारे में जानकारी संपादित करें"])}
}